import {useState} from 'react';

interface UseLoaderReturnType {
    visible: boolean;
    show: () => void;
    hide: () => void;
}

export const useLoader = (): UseLoaderReturnType => {
    const [visible, setVisible] = useState(false);
    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    return {
        visible,
        show,
        hide,
    };
};
